import { createElement, Component } from 'react';
import { store } from '../store';
import withStyles, { WithStyles } from 'react-jss';
import { observer } from 'mobx-react';
import { flowRight } from 'lodash';

const svg = require('../components/icons/support.svg');
const settings = require('../components/icons/settings.svg');
const components = require('../components/icons/components.svg');
const column = require('../components/icons/column.svg');
const backbutton = require('../components/icons/backbutton.svg');

const styles = {
    leftMenuBar: {
        width: 105,
        backgroundColor: '#FDFDFD',
        color: '#CDCED1',
    },
    selectedItem: {
        width: '90px',
        borderLeft: '5px solid #051931',
        color: '#FFFFFF',
        height: '70px',
        textAlign: 'center',
    },
    icon: {
        marginTop: '10px',
        '&:hover': {
            color: '#051931',
        },
    },

    panel: {
        display: 'flex',
        flexDirection: 'row',
        height: '70px',
    },
    sub_panel: {
        width: 110,
        height: 70,
        padding: 1,
        boxSizing: 'border-box',
        textAlign: 'center',
    },
    label: {
        fontSize: '13px',
        fontWeight: '500',
        lineHeight: '20px',
        display: 'block',
        color: '#292929',
    },
};

interface IProps extends WithStyles<typeof styles> {}

class LeftMenuBar extends Component<IProps, any> {
    render() {
        let { classes } = this.props;
        return (
            <div className={classes.leftMenuBar}>
                {store.ui.left_panel_view !== 'settings' ? (
                    [
                        {
                            view: 'component',
                            name: 'Elements',
                            icon: components,
                        },
                        {
                            view: 'column',
                            name: 'Rows',
                            icon: column,
                        },
                        {
                            view: 'page_settings',
                            name: 'Settings',
                            icon: settings,
                        },
                    ].map((i) => {
                        return (
                            <div key={i.view} onClick={(e) => ((store.ui.prev_view = i.name === 'Settings' ? store.ui.left_panel_view : store.ui.prev_view), (store.ui.left_panel_view = i.view))} className={store.ui.left_panel_view === i.view ? classes.selectedItem : classes.panel}>
                                <span className={classes.sub_panel}>
                                    <img src={i.icon} className={classes.icon} />
                                    <span className={classes.label}>{i.name}</span>
                                </span>
                            </div>
                        );
                    })
                ) : (
                    <div onClick={(e) => (store.ui.left_panel_view = 'component')}>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                            }}>
                            <img src={backbutton} style={{ margin: '5px' }} />
                            <span
                                style={{
                                    color: 'black',
                                    margin: '10px',
                                }}>
                                Done
                            </span>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default flowRight([withStyles(styles), observer])(LeftMenuBar);
